import classNames from "classnames";
import * as React from "react";
import { MutableRefObject, useEffect, useState } from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { Map } from "ol";
import { DrawingContextProvider } from "../Contexts/DrawingContext";
import { PopupBody } from "../Popups/Popup";
import { DrawingTools } from "./Drawing/DrawingTools";
import { useAppContext } from "../Contexts/AppContext";
import { useMap } from "../Map/useMap";
import { LayersMenu } from "../Popups/LayersMenu";
import { HelpPopup } from "../Popups/HelpPopup";
import { BasemapSwitch } from "../Map/Buttons/BasemapSwitch";
import "./DrawingForm.scss";

let mapRef: MutableRefObject<Map>;

export const DrawingForm = (): JSX.Element => {
    const [forceUpdate, setForceUpdate] = useState<number>(0);

    const { isMobile, hasMap, layersMenuVisible } = useAppContext();
    const { drawingMenuVisible, drawingInfoVisible } = useRegistrationContext();

    const ref = React.useRef<HTMLDivElement>();
    mapRef = React.useRef<Map>();
    mapRef.current = useMap(ref, { features: null, forceUpdate });

    useEffect(() => {
        document.getElementsByClassName("fs-container")[0].classList.add("map-form");
        setTimeout(() => mapRef.current.updateSize(), 0);
        hasMap && setForceUpdate(Date.now());
    }, [hasMap]);

    return (
        <>
            <div className="map-container">
                <div ref={ref} className="map" />
            </div>

            {mapRef.current ? (
                <>
                    <BasemapSwitch map={mapRef.current}></BasemapSwitch>
                    <div className={classNames("drawing-tools", { hidden: !drawingMenuVisible })}>
                        <PopupBody isMobile={isMobile}>
                            <DrawingContextProvider>
                                <DrawingTools></DrawingTools>
                            </DrawingContextProvider>
                        </PopupBody>
                    </div>
                    <LayersMenu visible={layersMenuVisible}></LayersMenu>
                </>
            ) : null}

            {drawingInfoVisible ? <HelpPopup></HelpPopup> : null}
        </>
    );
};

export const getMap = (): Map => mapRef.current;
